import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkIsEmployeeService } from './guards/is-employee.guard';
import { WorkIsLoggedInService } from './guards/is-logged-in.guard';
import { WorkRedirectToDashboardIfIsLoggedInService } from './guards/redirect-to-dashboard-if-is-logged-in.guard';
import { ApiTokenInterceptor } from './services/api-token-interceptor.service';
import { RequiresPermissionService } from './guards/requires-permission.guard';

@NgModule({
  imports: [CommonModule],
  providers: [
    WorkIsEmployeeService,
    WorkIsLoggedInService,
    WorkRedirectToDashboardIfIsLoggedInService,
    ApiTokenInterceptor,
    RequiresPermissionService,
  ],
})
export class WorkAuthenticationModule {
}
